import { getData, postData, } from "@/utils/http";
import config from "@/config"
export default {
    namespaced: true,
    state: {
        tableLoading: true,
        addLoading: false,
        activeItem: null,
        tableList: [],
        name:"",
        idCard:"",
		pageIndex:1,
		total:0,
		deptId:"",

         phone:"",
        driverType:"",
         status:"",


    },
    mutations: {
        CHANGE_TABLE_LOADING(state, tableLoading) {
            state.tableLoading = tableLoading;
        },
        CHANGE_ADD_LOADING(state, addLoading) {
            state.addLoading = addLoading;
        },
        CHANGE_TABLE_DATA(state, changeData) {
            state.tableList = changeData.data.rows;
            state.total = changeData.total;
        },
        CHANGE_ACTIVE_ITEM(state, item) {
            state.activeItem = item;
        },
        CHANGE_SEARCH_COLL(state, changeData) {
            if (changeData["changeKey"] == "orgId" && typeof changeData["data"] != "object") {
                state[changeData["changeKey"]] = [changeData["data"]];
            } else {
                state[changeData["changeKey"]] = changeData["data"];
            }
        },
        CHANGE_TABLE_INDEX(state, value) {
            state.pageIndex = value;
        }
    },
    actions: {
        //获取内部车辆列表
        getList({ commit, state },deptId) {
            return new Promise((resolve) => {
                getData(`logistics/driver/unbind/page?name=${state.name}&idCard=${state.idCard}&page=${state.pageIndex}&size=${config.pageSize}&deptId=${deptId}&phone=${state.phone}&driverType=${state.driverType}&status=${state.status}`).then((res) => {
                    if (res.state == 1) {
                        commit("CHANGE_TABLE_DATA", res);
                        resolve({
                            state: 1,
                            msg: "操作成功"
                        });
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg
                        });
                    }
                })
            })
        },

        //保存
        add({commit},addData){
            return new Promise((resolve)=>{
                postData(`logistics/driver/save`,addData).then((res)=>{
                    if(res.state==1){
                        resolve({
                            state:1,
							data:res.data.id,
                            msg:"操作成功"
                        });
                    }else{
                        resolve({
                            state:0,
							data:null,
                            msg:res.msg
                        });
                    }
                })
            })
        },


         //获取导出的数据
        getExportData({ commit, state },data) {
            return new Promise((resolve) => {
                getData(`logistics/driver/unbind/page?name=${state.name}&idCard=${state.idCard}&page=${state.pageIndex}&size=${data.total}&deptId=${data.deptId}&phone=${state.phone}&driverType=${state.driverType}&status=${state.status}`).then((res) => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data:res.data.rows,
                            msg: "操作成功"
                        });
                    } else {
                        resolve({
                            state: 0,
                            data:[],
                            msg: res.msg
                        });
                    }
                })
            })
        },



		 //获取车辆证件有效数据
        getPeriodList({commit,state}){
            return new Promise((resolve) => {
                getData(`logistics/driver/get/period/list/${state.activeItem.id}`).then((res) => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            msg: "操作成功",
                            data:res.data
                        });
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg,
                            data:[]
                        });
                    }
                })
            })
        },

        //保存车辆证件信息
        savePeriod({commit},addData){
            return new Promise((resolve)=>{
                postData(`logistics/driver/add/period`,addData).then((res)=>{
                    if(res.state==1){
                        resolve({
                            state:1,
                            msg:"操作成功"
                        });
                    }else{
                        resolve({
                            state:0,
                            msg:res.msg
                        });
                    }
                })
            })
        },

        //修改证件信息
        updatePeriod({commit},addData){
            return new Promise((resolve)=>{
                postData(`logistics/driver/update/period`,addData).then((res)=>{
                    if(res.state==1){
                        resolve({
                            state:1,
                            msg:"操作成功"
                        });
                    }else{
                        resolve({
                            state:0,
                            msg:res.msg
                        });
                    }
                })
            })
        },


		//获取已经启用的字典值
		getAllowValue({ commit, state },type){
			return new Promise((resolve) => {
				getData(`logistics/sys/dict/data/type/${type}`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
                            msg: "操作成功",
                            data:res.data
						});
					} else {
						resolve({
							state: 0,
							data: [],
							msg: res.msg
						});
					}
				})
			})
		},

        //删除证件信息
		removePer({commit,state},id){
			return new Promise((resolve)=>{
                postData(`logistics/driver/remove/period/${id}`).then((res)=>{
					if(res.state==1){
						resolve({
                            state:1,
                            msg:"操作成功"
                        });
                    }else{
                        resolve({
                            state:0,
                            msg:res.msg
                        });
                    }
                })
            })
		},

		getAllowOrg({commit,state},year){
            return new Promise((resolve) => {
                getData(`logistics/sys/dept/get/list`).then((res) => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            msg: "操作成功",
                            data:res.data
                        });
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg,
                            data:[]
                        });
                    }
                })
            })
        },
		




        //写入当前操作条目
        setActiveItem({ commit }, item) {
            commit("CHANGE_ACTIVE_ITEM", item)
        },

        //写入查询条件
        setSearchData({ commit }, changeData) {
            commit("CHANGE_SEARCH_COLL", changeData)
        },
        //修改分页
        setPageIndex({ commit }, value) {
            commit("CHANGE_TABLE_INDEX", value)
        },
        //修改添加loading
        changeAddLoading({ commit }, value) {
            commit("CHANGE_ADD_LOADING", value)
        },
        //修改添加loading
        changeListLoading({ commit }, value) {
            commit("CHANGE_TABLE_LOADING", value)
        }

    }
}
